import http from '@/plugins/http'
const adminApi = process.env.VUE_APP_ADMIN_API;
//我的车型测评首页
export const getReportIndexData = (params={}) => {
    const url = adminApi  + 'drivingReport/index'
    return http.fetchGet(url, params);
}
//我的车型评测 推荐车型
export const getRecommendCar = (params={}) => {
    const url = adminApi  + 'drivingReport/recommend'
    return http.fetchGet(url, params);
}
//排行榜
export const getRankData = (params={}) => {
    const url = adminApi  + 'drivingReport/rank'
    return http.fetchGet(url, params);
}
export const getRankNodeData = (params={}) => {
    const url = adminApi  + 'drivingReport/rankNode'
    return http.fetchGet(url, params);
}
// 车型综述
export const getCarSummaryData = (params={}) => {
    const url = adminApi  + 'drivingReport/car/detail'
    return http.fetchGet(url, params);
}
//指标得分(性能,功能,旅途)
export const getCarScore = (params={}) => {
    const url = adminApi  + 'drivingReport/car/node'
    return http.fetchPost(url, params);
}
//指标得分(创新)
export const getCarScoreInnovate = (params={}) => {
    const url = adminApi  + 'drivingReport/car/innovateNode'
    return http.fetchPost(url, params);
}
//获取节点测评详情
export const getTestDetail = (params={}) => {
    const url = adminApi  + 'drivingReport/car/nodeDetail'
    return http.fetchPost(url, params);
}
//获取创新指标详情
export const getInnovateDetail = (params={}) => {
    const url = adminApi  + 'drivingReport/car/innovateNodeDetail'
    return http.fetchPost(url, params);
}
//获取创新标杆分析
export const getInnovateLineDetail = (params={}) => {
    const url = adminApi  + 'drivingReport/car/innovateAnalysisData'
    return http.fetchPost(url, params);
}
//获取一级标杆分析
export const getNodeLineDetail = (params={}) => {
    const url = adminApi  + 'drivingReport/car/functionAnalysisData'
    return http.fetchPost(url, params);
}
//获取二级标杆分析
export const getNodeLineTwoDetail = (params={}) => {
    const url = adminApi  + 'drivingReport/car/functionAnalysisDetail'
    return http.fetchPost(url, params);
}
//获取二级标杆
//添加竞品车型
export const addCompareCar = (params={}) => {
    const url = adminApi  + 'drivingReport/user/addCompareCar'
    return http.fetchPost(url, params);
}
//删除竞品车型
export const delCompareCar = (params={}) => {
    const url = adminApi  + 'drivingReport/user/delCompareCar'
    return http.fetchPost(url, params);
}
//获取竞品车型列表
export const getCompareCarList = (params={}) => {
    const url = adminApi  + 'drivingReport/user/compareCarList'
    return http.fetchPost(url, params);
}
//更换首页的车型
export const changeUserCar = (params={}) => {
    const url = adminApi  + 'drivingReport/user/updatePersonalizationCar'
    return http.fetchPost(url, params);
}

//搜索叶子节点
export const searchNode = (params={}) => {
    const url = adminApi  + 'drivingReport/search/node'
    return http.fetchPost(url, params);
}

//核心场景分析页面 二级节点列表
export const getParentNodes = (params={}) => {
    const url = adminApi  + 'drivingReport/coreScene/tree'
    return http.fetchPost(url, params);
}
//核心场景分析页面 二级节点列表
export const getNodeVideos = (params={}) => {
    const url = adminApi  + 'drivingReport/coreScene/video'
    return http.fetchPost(url, params);
}

//添加收藏车型
export const addCollect = (params={}) => {
    const url = adminApi  + 'drivingReport/user/addCollect'
    return http.fetchPost(url, params);
}
//删除收藏车型
export const delCollect = (params={}) => {
    const url = adminApi  + 'drivingReport/user/delCollect'
    return http.fetchPost(url, params);
}

// 智能搜索车型列表
export const getSearchModel = (params={}) => {
    const url = adminApi  + 'drivingReport/car/permissionInfo'
    return http.fetchPost(url, params);
}
// 智能搜索结果
// ?model_id=&keyword=
export const getSearchResoult = (params={}) => {
    const url = adminApi  + 'drivingReport/search/nodeCompare'
    return http.fetchPost(url, params);
}
// 搜索车型
export const getSearchCar = (params={}) => {
    const url = adminApi  + 'drivingReport/search/car'
    return http.fetchPost(url, params);
}
// 搜索车型-创新
export const getSearchResoultCx = (params={}) => {
    const url = adminApi  + 'drivingReport/search/innovateNodeCompare'
    return http.fetchPost(url, params);
}